export const clearCustomer = () => {
  localStorage.removeItem("customerInfo");
  localStorage.removeItem("buildingInfo");
  localStorage.removeItem("isImidChecked");
  localStorage.removeItem("isAddBuildingChecked");
  localStorage.removeItem("imidDevices");
  localStorage.removeItem("tenantData");
  localStorage.removeItem("addMetersFormData");
  localStorage.removeItem("isMeterChecked");
  return null;
};
